import React from "react";

/**
 * Konum/mekan ikonları — İç Mekan / Dış Mekan başlıkları için.
 * Emoji yerine 1.5px stroke minimal SVG. currentColor kullanır,
 * kapsayan öğenin renk değerini alır.
 *
 * Kullanım:
 *   import { IcIcon, DisIcon } from "./LocationIcons";
 *   <IcIcon />
 *   <IcIcon size={16} className="mr-1" />
 */

const baseProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export function IcIcon({ size = 18, className = "", style = {} }) {
  return (
    <svg width={size} height={size} className={className} style={style} {...baseProps} aria-hidden="true">
      {/* Ev outline — modern, sade */}
      <path d="M3 11.5L12 4l9 7.5" />
      <path d="M5 10v9.5a1 1 0 001 1h3.5v-6h5v6H18a1 1 0 001-1V10" />
    </svg>
  );
}

export function DisIcon({ size = 18, className = "", style = {} }) {
  return (
    <svg width={size} height={size} className={className} style={style} {...baseProps} aria-hidden="true">
      {/* Yaprak — organik, dış mekan */}
      <path d="M11 20A7 7 0 019.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z" />
      <path d="M2 21c0-3 1.85-5.36 5.08-6" />
    </svg>
  );
}

/** İkon + label — yaygın kullanım için pratik shortcut */
export function LocLabel({ type, size = 16, gap = 6, children, className = "", style = {} }) {
  const Ic = type === "dis" ? DisIcon : IcIcon;
  return (
    <span
      className={className}
      style={{ display: "inline-flex", alignItems: "center", gap, ...style }}
    >
      <Ic size={size} />
      {children}
    </span>
  );
}
